import { useState } from 'react';
import { api, ErroreApi } from '../api';

export function Accesso({ onEntrato }: { onEntrato: () => void }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errore, setErrore] = useState<string | null>(null);
  const [attesa, setAttesa] = useState(false);

  const entra = async (e: React.FormEvent) => {
    e.preventDefault();
    setAttesa(true);
    setErrore(null);
    try {
      await api.post('/api/accesso', { email, password });
      onEntrato();
    } catch (err) {
      setErrore(err instanceof ErroreApi ? err.message : 'Accesso non riuscito.');
    } finally {
      setAttesa(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-inchiostro-100 p-4">
      <form onSubmit={entra} className="w-full max-w-sm rounded-lg border border-inchiostro-200 bg-white p-7 shadow-sm">
        <h1 className="text-xl font-semibold tracking-tight">Mastro</h1>
        <p className="mt-1 text-sm text-inchiostro-500">Tesoreria e previsione di cassa</p>

        <label className="mt-6 block">
          <span className="etichetta">Email</span>
          <input
            className="campo"
            type="email"
            autoComplete="username"
            autoFocus
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </label>

        <label className="mt-4 block">
          <span className="etichetta">Password</span>
          <input
            className="campo"
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>

        {errore && (
          <p role="alert" className="mt-4 rounded-md border border-allerta/30 bg-allerta-chiaro px-3 py-2 text-sm text-allerta">
            {errore}
          </p>
        )}

        <button type="submit" className="bottone-primario mt-6 w-full justify-center" disabled={attesa}>
          {attesa ? 'Accesso in corso…' : 'Entra'}
        </button>
      </form>
    </div>
  );
}
